//component
import { RadioImageButton } from 'thrive-components';

//helpers and hooks
import { BuildPath } from '@/helpers/Paths';
import UseListLayout from './ListLayout.hooks';

import { ListLayoutTypes } from "@/interfaces/listLayout";

import "../../../../css/content/appearance/list-layout.scss";



const ListLayout = ({defaultSelectedType}: {defaultSelectedType: string}) => {
    const {selectedLayout, setSelectedLayout, layoutTypes} = UseListLayout(defaultSelectedType);

    return (
        <div className="list-layout-container" data-testid="list-layout-container">
            {layoutTypes.map(([key, value], index) => {
                const isChecked = selectedLayout === value.key;

                return (
                    <RadioImageButton
                        key={key}
                        id={index}
                        text={value.label}
                        isChecked={isChecked}
                        onClick={() => setSelectedLayout(value.key)}
                        imageSrc={`${BuildPath()}/images/listLayout/${key}.png`}
                        imageAlt={`${value.label} View Preview`}
                        isNew={value.key === ListLayoutTypes.socialList.key}
                    />
                );
            })}

            <input
                className='sr-only'
                type="hidden"
                name="Layout"
                id="LayoutHidden"
                value={selectedLayout}
            />
        </div>
    );  
}

export default ListLayout;